import axiosInstance from './axiosInstance';
import { API_CONFIG } from './config';
import { getRequesterId } from '../utils/storageManager';
import {
  FreeDriverRequest,
  FreeDriverResponse,
  GetFreeDriversRequest,
  GetFreeDriversResponse,
} from './types';

export const driverService = {
  /**
   * Free all drivers for the current requester
   */
  freeDrivers: async (): Promise<FreeDriverResponse> => {
    try {
      const requesterId = getRequesterId();
      const response = await axiosInstance.post(
        API_CONFIG.ENDPOINTS.FREE_DRIVER,
        null,
        {
          params: {
            requesterId,
          },
        }
      );
      return {
        data: response.data,
        status: response.status,
        message: 'All drivers freed successfully',
      };
    } catch (error) {
      return {
        data: error?.response ?? null,
        status: error?.response?.status ?? 500,
        message: `Failed to free drivers: ${error.message}`,
        }
    }
  },

  /**
   * Get all free drivers
   */
  getFreeDrivers: async (): Promise<GetFreeDriversResponse> => {
    try {
      const requesterId = getRequesterId();
      const response = await axiosInstance.get(
        API_CONFIG.ENDPOINTS.GET_FREE_DRIVERS,
        {
          params: {
            requesterId,
          },
        }
      );
      return { data: response.data, status: response.status }
    } catch (error) {
        return {
            data: error?.response ?? null,
            status: error?.response?.status ?? 500,
        };
    }
  },
};
